import { Box, Typography } from "@mui/material";
import useColors from "../api/hooks/useColors";

export default function Header({
  title = null,
  title2 = null,
  subtitle = null,
}) {
  const colors = useColors();

  return (
    <Box mt="10px" mb="12px" justify-content="space-between">
      {title && (
        <Typography variant="h5" color={colors.text_primary}>
          {title}
        </Typography>
      )}
      {title2 && (
        <Typography variant="h6" color={colors.text_primary}>
          {title2}
        </Typography>
      )}
      {subtitle && (
        <Box sx={{ mt: "8px" }}>
          <Typography variant="subtitle1" color={colors.text_primary}>
            {subtitle}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
